/* Layer ID Generator */
/* Generate a RANDOM ID for Text Photo Layres */

const LayerIdGenerator = {
  generate: () => {
    const date = Date.now();
    const randomFactor = Math.floor(Math.random() * 1000);
    const generated = `${date}_${randomFactor}`;
    return generated;
  }
}

export default LayerIdGenerator;